module.exports = __webpack_public_path__ + "src/components/assets/icon-shopping-category.41db215d3d33f2b4d1d481718ce6daea.svg";